import { QuickQuestionOption } from '@gelato-api-ui/core/quick-questions/constants/quck-question-option';

export const ReviewSiteOptions: QuickQuestionOption[] = [
  { id: 'shopify', name: 'Shopify' },
  { id: 'wix', name: 'Wix' },
  { id: 'trustpilot', name: 'Trustpilot' },
  { id: 'other', name: 'txt_other' },
];
